import { MENU_ICONS } from '@/constants';
import { ControlledMenu, MenuItem } from '@szhsin/react-menu';
import '@szhsin/react-menu/dist/index.css';
import React, { useState } from 'react';

interface TabContextMenuProps {
    children: React.ReactNode;
    onCloseTab: () => void;
    onCloseOthers: () => void;
    hasMultipleTabs: boolean;
}

interface MenuState {
    isOpen: boolean;
    anchorPoint: { x: number; y: number };
}

export const TabContextMenu: React.FC<TabContextMenuProps> = React.memo(
    ({ children, onCloseTab, onCloseOthers, hasMultipleTabs }) => {
        const [menuState, setMenuState] = useState<MenuState>({
            isOpen: false,
            anchorPoint: { x: 0, y: 0 },
        });

        const handleContextMenu = (e: React.MouseEvent) => {
            if (typeof document.hasFocus === 'function' && !document.hasFocus()) return;

            e.preventDefault();
            e.stopPropagation();
            setMenuState({
                isOpen: true,
                anchorPoint: { x: e.clientX, y: e.clientY },
            });
        };

        const handleClose = () => {
            setMenuState(prev => ({
                ...prev,
                isOpen: false,
            }));
        };

        return (
            <>
                <div onContextMenu={handleContextMenu}>
                    {children}
                    <ControlledMenu
                        anchorPoint={menuState.anchorPoint}
                        state={menuState.isOpen ? 'open' : 'closed'}
                        direction='right'
                        onClose={handleClose}
                    >
                        <MenuItem
                            onClick={() => {
                                onCloseTab();
                                handleClose();
                            }}
                            className={hasMultipleTabs ? undefined : 'opacity-50 cursor-not-allowed'}
                        >
                            <span className='w-4 text-xs text-center mr-2'>{MENU_ICONS.CLOSE}</span>
                            Close
                        </MenuItem>

                        <MenuItem
                            onClick={
                                hasMultipleTabs
                                    ? () => {
                                          onCloseOthers();
                                          handleClose();
                                      }
                                    : undefined
                            }
                            disabled={!hasMultipleTabs}
                            className={!hasMultipleTabs ? 'opacity-50 cursor-not-allowed' : undefined}
                        >
                            <span className='w-4 text-xs text-center mr-2'>{MENU_ICONS.CLOSE_OTHERS}</span>
                            Close Others
                        </MenuItem>
                    </ControlledMenu>
                </div>
            </>
        );
    }
);
